import { CUSTOM_FILTERS } from "@/config/list";
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { ChevronDown } from "lucide-react";
import { BlockageStatusBadge } from "@/components/badges/BlockageStatusBadge";
import { ListFilters } from "@/types/list";

const BLOCKAGE_STATUSES: Dryp.BlockageStatusValues[] = [
	"Normal",
	"Warning",
	"Blocked",
	"Full",
	"Undetermined",
	"NoData",
];

type StatusTypeFilterProps = {
	filters: ListFilters;
};

export const StatusTypeFilter = ({ filters }: StatusTypeFilterProps) => {
	const value = filters.getFilter(CUSTOM_FILTERS.status) as Dryp.BlockageStatusValues | undefined;

	const clearFilter = () => {
		filters.clearFilter(CUSTOM_FILTERS.status);
	};

	const onChange = (selected?: Dryp.BlockageStatusValues) => {
		if (selected === undefined) {
			clearFilter();
		} else {
			filters.setFilter(CUSTOM_FILTERS.status, selected);
		}
	};

	return (
		<div className="relative z-10">
			<div className="flex flex-col space-y-1">
				<span className="text-xs font-medium text-muted-foreground">Status</span>

				<DropdownMenu>
					<DropdownMenuTrigger asChild>
						<Button variant="outline" size="sm" className="justify-start gap-2" aria-pressed={!!value}>
							{value ? (
								<BlockageStatusBadge
									mode="dot"
									status={{
										status: value,
										statusLabel: value,
										statusDetail: "",
									}}
								/>
							) : (
								<span className="font-semibold text-muted-foreground">All</span>
							)}
							<ChevronDown className="ml-2 h-4 w-4 opacity-50" />
						</Button>
					</DropdownMenuTrigger>

					<DropdownMenuContent align="start">
						<DropdownMenuItem
							onSelect={() => onChange(undefined)}
							className={!value ? "font-semibold bg-muted" : ""}
						>
							All
						</DropdownMenuItem>

						{BLOCKAGE_STATUSES.map(status => (
							<DropdownMenuItem
								key={status}
								onSelect={() => onChange(status)}
								className={value === status ? "font-semibold bg-muted" : ""}
							>
								<BlockageStatusBadge
									mode="dot"
									status={{
										status,
										statusLabel: status,
										statusDetail: "",
									}}
								/>
							</DropdownMenuItem>
						))}
					</DropdownMenuContent>
				</DropdownMenu>
			</div>
		</div>
	);
};
